<script setup lang="ts">
defineProps<{
  senderName: string
  senderEmail: string
}>()

const { t } = useI18n()

const currentTime = computed(() => {
  const now = new Date()
  return now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
})
</script>

<template>
  <div class="flex flex-col gap-6 h-full">
    <div>
      <h2 class="text-lg font-semibold text-foreground">
        {{ t('pages.domain.sender.preview.title') }}
      </h2>
      <p class="text-sm text-muted-foreground mt-1">
        {{ t('pages.domain.sender.preview.description') }}
      </p>
    </div>

    <div class="flex-1">
      <BasePhone size="md" hide-bottom>
        <div class="bg-white h-full">
          <div class="flex items-center justify-between px-4 pt-3 pb-1">
            <span class="text-[10px] font-medium text-foreground">{{ currentTime }}</span>
            <div class="flex items-center gap-1">
              <div class="flex items-end gap-0.5">
                <div class="w-0.5 h-1 bg-foreground rounded-sm"></div>
                <div class="w-0.5 h-1.5 bg-foreground rounded-sm"></div>
                <div class="w-0.5 h-2 bg-foreground rounded-sm"></div>
                <div class="w-0.5 h-2.5 bg-border rounded-sm"></div>
              </div>
              <span class="text-[10px] font-medium text-foreground">5G</span>
              <div class="w-5 h-2.5 border border-foreground rounded-sm flex items-center p-0.5">
                <div class="w-2/3 h-full bg-foreground rounded-xs"></div>
              </div>
            </div>
          </div>

          <div class="p-2">
            <p class="text-lg font-bold text-foreground">{{ t('pages.domain.sender.preview.allEmails') }}</p>
          </div>

          <div class="px-2 py-2.5 border-b border-border">
            <div class="flex items-start gap-2.5">
              <div class="w-9 h-9 rounded-lg bg-border flex items-center justify-center shrink-0">
                <span class="text-white text-sm font-medium">
                  {{ senderName ? senderName.charAt(0).toUpperCase() : 'E' }}
                </span>
              </div>

              <div class="flex-1 min-w-0">
                <div class="flex items-center justify-between">
                  <p class="font-semibold text-sm text-foreground truncate">
                    {{ senderName || t('pages.domain.sender.preview.defaultName') }}
                  </p>
                  <BaseIcon name="HeroChevronRightIconOutline" class="w-4 h-4 text-muted-foreground/60 shrink-0" />
                </div>

                <p class="text-[12px] text-muted-foreground truncate">
                  {{ senderEmail || '-' }}
                </p>
              </div>
            </div>
          </div>

          <div
            v-for="i in 2"
            :key="i"
            class="px-2 py-2.5 border-b border-border"
            :style="{ opacity: 0.7 - (i - 1) * 0.24 }"
          >
            <div class="flex items-start gap-2.5">
              <div class="w-9 h-9 rounded-lg bg-border shrink-0"></div>
              <div class="flex-1 pt-1">
                <div class="h-3 w-24 bg-border rounded mb-1.5"></div>
                <div class="h-2.5 w-32 bg-muted rounded"></div>
              </div>
            </div>
          </div>
        </div>
      </BasePhone>
    </div>
  </div>
</template>
